const menuItems = {
  firstBlock: [
    {
      title: 'Обучение',
      link: '/education',
      icon: 'hat',
      isDisabled: false,
      digit: null,
      label: 'education',
      useNuxtLink: true
    },
    {
      title: 'Задания',
      link: '/education/homeworks',
      icon: 'homework',
      isDisabled: false,
      digit: 0,
      label: 'homeworks',
      useNuxtLink: true
    },
    {
      title: 'Анкеты',
      link: '/education/questionnaires',
      icon: 'form',
      isDisabled: false,
      digit: 0,
      label: 'questionnaires',
      useNuxtLink: true
    },
    {
      title: 'Наставники',
      link: '/education/mentor',
      icon: 'profile',
      isDisabled: false,
      digit: null,
      label: 'mentors',
      useNuxtLink: true
    }
  ],
  secondBlock: [
    {
      title: 'Журнал',
      link: 'https://gb.ru/posts',
      icon: 'journal',
      isDisabled: false,
      digit: null,
      useNuxtLink: false,
      label: 'posts'
    }
    // {
    //   title: 'GeekSchool',
    //   link: 'https://gb.ru/courses/geek-school',
    //   icon: 'school',
    //   isDisabled: false,
    //   digit: null,
    //   label: 'courses'
    //   useNuxtLink: false
    // }
  ],
  settings: {
    title: 'Настройки',
    link: '/education/settings',
    icon: 'gear',
    isDisabled: false,
    digit: null,
    label: 'settings',
    useNuxtLink: true
  }
}

export default menuItems
